import React, { useEffect } from "react";
import { usePostalJp } from "use-postal-jp";
import { useSelector, useDispatch } from "react-redux";
import TextField from "@mui/material/TextField";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
  ARCHITECTURE,
  EQUIPMENT,
  FIREEQUIPMENT,
} from "./Word";

const typeMap = {
  [ARCHITECTURE]: CHANGE_DATA_ARCHITECTURE,
  [EQUIPMENT]: CHANGE_DATA_EQUIPMENT,
  [FIREEQUIPMENT]: CHANGE_DATA_FIREEQUIPMENT,
};

const addressKeyMap = {
  [ARCHITECTURE]: "a02_i2",
  [EQUIPMENT]: "e02_i2",
  [FIREEQUIPMENT]: "f02_i2",
};

export const InputZipCode = React.memo(
  ({ key_num, target_key_num, type, label = "", page }) => {
    const dispatch = useDispatch();
    const zipCode = useSelector(
      (state) => state[type]?.["B1"]?.[page]?.[key_num] ?? ""
    );
    const addressCode = useSelector(
      (state) => state[type]?.["B1"]?.[page]?.[target_key_num] ?? ""
    );

    const [address] = usePostalJp(zipCode, zipCode.length >= 7);

    // 🔁 郵便番号 → 住所に自動補完
    useEffect(() => {
      if (address && addressCode === "") {
        const addressKey = addressKeyMap[type];
        const actionType = typeMap[type];
        if (addressKey && actionType) {
          dispatch({
            type: actionType,
            payload: { [addressKey]: `${address.address1}${address.address2}` },
            bulding: "B1",
            page,
          });
        }
      }
    }, [address, addressCode, dispatch, page, type]);

    const handleChange = (e) => {
      const value = e.target.value;
      const actionType = typeMap[type];
      if (actionType) {
        dispatch({
          type: actionType,
          payload: { [key_num]: value },
          bulding: "B1",
          page,
        });
      }
    };

    return (
      <TextField
        fullWidth
        value={zipCode}
        variant="filled"
        onChange={handleChange}
        label={label}
      />
    );
  }
);
